import { RiCheckLine } from 'react-icons/ri'
import { TabId, ServerSideTabState, TrackingCodeTabState } from '../types'

interface TrackingTabsProps {
	activeTab: TabId
	serverSideState: ServerSideTabState
	trackingCodeState: TrackingCodeTabState
	onTabChange: (tab: TabId) => void
}

export const TrackingTabs = ({
	activeTab,
	serverSideState,
	trackingCodeState,
	onTabChange
}: TrackingTabsProps) => {
	const getServerSideTabClasses = () => {
		if (serverSideState === 'completed') {
			return 'text-[#0B9055] rounded-md'
		}
		if (serverSideState === 'skipped') {
			return 'text-t-gray-input rounded-md'
		}
		if (activeTab === 'server-side') {
			return 'text-t-email-blue border-b-2 border-[color:var(--tab-underline-active)]'
		}
		return 'text-t-gray-checkout'
	}

	// Tab 2 is only accessible after Tab 1 is skipped or completed
	const isTab2Accessible =
		serverSideState === 'skipped' || serverSideState === 'completed'

	const getTrackingCodeTabClasses = () => {
		if (!isTab2Accessible) {
			return 'text-t-gray-input cursor-not-allowed'
		}
		if (trackingCodeState === 'completed') {
			return 'text-[#0B9055] rounded-md'
		}
		if (activeTab === 'tracking-code') {
			return 'text-t-email-blue border-b-2 border-[color:var(--tab-underline-active)]'
		}
		return 'text-t-gray-checkout'
	}

	const getServerSideLabel = () => {
		if (serverSideState === 'skipped') {
			return '1. Server-side tracking (skipped)'
		}
		return '1. Server-side tracking'
	}

	return (
		<div className="flex gap-1 items-center border-b border-t-gray-input w-full">
			<button
				className={`md:h-[36px] px-3 py-2 text-[14px] leading-[20px] font-semibold font-inter flex items-center gap-1.5 md:whitespace-nowrap whitespace-normal overflow-hidden ${getServerSideTabClasses()}`}
				onClick={() => onTabChange('server-side')}
			>
				{serverSideState === 'completed' && (
					<RiCheckLine className="w-[13px] h-[13px] shrink-0" />
				)}
				{getServerSideLabel()}
			</button>
			<button
				className={`md:h-[36px] px-3 py-2 text-[14px] leading-[20px] font-semibold font-inter flex items-center gap-1.5 md:whitespace-nowrap whitespace-normal overflow-hidden ${getTrackingCodeTabClasses()}`}
				onClick={() => isTab2Accessible && onTabChange('tracking-code')}
				disabled={!isTab2Accessible}
			>
				{trackingCodeState === 'completed' && (
					<RiCheckLine className="w-[13px] h-[13px] shrink-0" />
				)}
				2. Tracking code installation
			</button>
		</div>
	)
}
